import { ReduxActionNameCreator } from "@services/ReduxActionNameCreator";

// Actions
const action = new ReduxActionNameCreator("loading");
export const SHOW_LOADING = action.make("show");
export const HIDE_LOADING = action.make("hide");

// Action creators
export const showLoading = () => ({ type: SHOW_LOADING });
export const hideLoading = () => ({ type: HIDE_LOADING });
